define('models/basket_product',['require','backbone','models/product'],function(require){

    var Backbone = require('backbone');

    var ProductModel = require('models/product');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                product: new ProductModel().attributes,
                count: 0,
                license: null
            };
        }
    });
});
